// extracted by mini-css-extract-plugin
export default {"deleted_row":"ReportOcrTableBlock_deleted_row__QlZFi"};